var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    stroke: "current"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2315 5109 c-640 -66 -1215 -355 -1647 -826 -621 -679 -828 -1645 -538 -2523 127 -387 332 -720 621 -1009 406 -405 901 -648 1494 -733 118 -17 512 -17 630 0 592 84 1089 328 1494 733 405 406 649 902 733 1494 17 118 17 512 0 630 -84 592 -328 1088 -733 1494 -396 395 -881 639 -1449 726 -126 19 -477 28 -605 14z m431 -580 c388 -38 760 -190 1064 -436 88 -71 246 -233 311 -318 620 -810 540 -1933 -187 -2635 -219 -212 -464 -361 -747 -455 -415 -138 -839 -138 -1256 1 -282 93 -525 242 -745 454 -231 224 -401 491 -500 791 -139 417 -139 838 -1 1256 138 418 418 780 790 1026 372 245 832 360 1271 316z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2165 3841 c-11 -5 -29 -19 -40 -31 -20 -22 -20 -38 -23 -906 l-2 -884 830 0 830 0 32 29 33 29 3 174 c4 200 -3 239 -51 268 -31 19 -55 20 -594 20 l-563 0 0 620 0 620 -29 32 -29 33 -189 2 c-103 1 -197 -1 -208 -6z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.dc730705.svg";
export { ForwardRef as ReactComponent };